import ParameterErrors from '../errors/ParameterErrors';
import Mesh from './Mesh';
import UrlHelper from '../core/UrlHelper'
const { throwNotProvided } = ParameterErrors;
export default class ModelFile {
    constructor(props) {
        const { rootUrl, fileName, url, code } = props;
        if (!code) throwNotProvided('code');
        this._code = code;
        if (url === null || url === undefined) {
            if (!rootUrl) this._throwMustProvideUrlOrRootUrlAndFileName("rootUrl");
            this._rootUrl = rootUrl;
            if (!fileName) this._throwMustProvideUrlOrRootUrlAndFileName('fileName');
            this._fileName = fileName;
        }
        else {
            const seperatedUrlComponents = UrlHelper.seperateUrlIntoRootUrlAndFileName(url);
            this._rootUrl = seperatedUrlComponents[0];
            this._fileName = seperatedUrlComponents[1];
        }
    }
    _throwMustProvideUrlOrRootUrlAndFileName() {
        throw new Error('You must provide either the parameters "rootUrl" and "fileName" or "url"');

    }
    get code() {
        return this._code;
    }
    get rootUrl() {
        return this._rootUrl;
    }
    get fileName() {
        return this._fileName;
    }

}
